var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("employee-form", {
        ref: "employeeForm",
        on: {
          "employee-submitted": function ($event) {
            _vm.updateList += 1
          },
          removed: function ($event) {
            _vm.updateList += 1
          },
        },
      }),
      _c("m-manage-filters", {
        attrs: {
          active: _vm.manageFiltersModal,
          costructor: true,
          "enabled-fields": _vm.enabledFields,
          module: "employees",
          query: _vm.query,
          "field-values": _vm.fieldValues,
        },
        on: {
          close: function ($event) {
            _vm.manageFiltersModal = null
          },
          openConstructorModal: _vm.openConstructorModal,
          setFilters: _vm.setFilters,
        },
      }),
      _c("m-filter-constructor", {
        attrs: {
          active: _vm.constructorModal,
          module: "employees",
          "current-filters": _vm.currentFilters,
        },
        on: {
          close: _vm.closeConstructorModal,
          save: _vm.constructorSave,
          applyFiltersFields: _vm.applyFiltersFields,
        },
      }),
      _c(
        "div",
        { staticClass: "layout employees" },
        [
          _vm.isLoadingExcelFile
            ? _c("c-loader", {
                attrs: {
                  label: "Загружаем список сотрудников в Excel-файл",
                  active: _vm.isLoadingExcelFile,
                  height: "fixed",
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "layout-header" }, [
            _c("div", { staticClass: "layout-title" }, [_vm._v("Сотрудники")]),
            _c("div", { staticClass: "layout-header-actions" }, [
              _c("div", { staticClass: "layout-header-action" }, [
                _c("div", { staticClass: "layout-header-action-dropdown" }, [
                  _c("div", {
                    staticClass: "c-button__dropdown__container__overlay",
                    class: {
                      "c-button__dropdown__container__overlay__active":
                        _vm.isActiveDropdown,
                    },
                    on: {
                      click: function ($event) {
                        _vm.isActiveDropdown = false
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "c-button c-button_with-icon c-button_responsive",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-button__wrapper",
                          class: {
                            "c-button__wrapper__active": _vm.isActiveDropdown,
                          },
                          on: {
                            click: function ($event) {
                              _vm.isActiveDropdown = !_vm.isActiveDropdown
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "c-button__label__left" }, [
                            _vm._v("Действия"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "c-button__icon__right" },
                            [_c("c-icon", { attrs: { icon: "arrow" } })],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-button__dropdown__container c-button__dropdown__container__left",
                              class: {
                                "c-button__dropdown__container__active":
                                  _vm.isActiveDropdown,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-button__dropdown__container__list",
                                },
                                [
                                  _c(
                                    "google-form",
                                    {
                                      ref: "googleForm",
                                      staticClass:
                                        "c-button__dropdown__container__list__item",
                                    },
                                    [
                                      _c("c-icon", {
                                        attrs: {
                                          icon: "google",
                                          color: "success",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-button__dropdown__container__list__item__label",
                                        },
                                        [_vm._v("Выгрузить в Google Таблицы")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-button__dropdown__container__list__item",
                                      class: {
                                        disabled:
                                          !_vm.$refs.route ||
                                          _vm.$refs.route._data.isLoadingTable,
                                      },
                                      on: {
                                        click: _vm.exportEmployeeTableToExcel,
                                      },
                                    },
                                    [
                                      _c("c-icon", {
                                        attrs: {
                                          icon: "excel",
                                          color: "success",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-button__dropdown__container__list__item__label",
                                        },
                                        [_vm._v("Выгрузить в Excel")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-button__dropdown__container__list__item",
                                      class: {
                                        disabled:
                                          !_vm.$refs.route ||
                                          _vm.$refs.route._data.isLoadingTable,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.manageFiltersModal = "list"
                                        },
                                      },
                                    },
                                    [
                                      _c("c-icon", {
                                        attrs: { icon: "filter" },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-button__dropdown__container__list__item__label",
                                        },
                                        [_vm._v("Управление фильтрами")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.isAllowedToEditAllWorkers
                ? _c(
                    "div",
                    {
                      staticClass:
                        "layout-header-action layout-header-action-new-employee",
                    },
                    [
                      _c("c-button-2", {
                        attrs: {
                          size: "small",
                          label: "Новый сотрудник",
                          icon: {
                            icon: "plus",
                            color: "blue",
                          },
                        },
                        on: { click: _vm.goToCreateEmployee },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "layout-header-action layout-header-action-new-employee-mobile",
                },
                [
                  _c("c-button-2", {
                    attrs: {
                      size: "small",
                      responsive: "",
                      label: "Новый сотрудник",
                      icon: {
                        icon: "plus",
                        color: "blue",
                      },
                    },
                    on: { click: _vm.goToCreateEmployee },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.filtersInited
            ? [
                _vm.enabledFields && _vm.enabledFields.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "employees__fields",
                        class: { employees__fields_active: _vm.filtersVisible },
                      },
                      [
                        _c(
                          "b-row",
                          { attrs: { "align-v": "center", cols: "12" } },
                          [
                            _vm._l(_vm.enabledFields, function (field) {
                              return _c(
                                "b-col",
                                {
                                  key: field.name,
                                  attrs: {
                                    sm: "12",
                                    md: "6",
                                    lg: "" + field.cols,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "employees__fields-item" },
                                    [
                                      field.type === "text"
                                        ? _c("c-input", {
                                            attrs: {
                                              label: field.label,
                                              clearable: field.clearable
                                                ? field.clearable
                                                : undefined,
                                              placeholder: field.placeholder
                                                ? field.placeholder
                                                : undefined,
                                            },
                                            model: {
                                              value: field.value,
                                              callback: function ($$v) {
                                                _vm.$set(field, "value", $$v)
                                              },
                                              expression: "field.value",
                                            },
                                          })
                                        : _vm._e(),
                                      field.type === "select" && !field.groups
                                        ? _c("c-input", {
                                            attrs: {
                                              type: field.type,
                                              label: field.label,
                                              checkbox: field.checkbox,
                                              "checkbox-value":
                                                field.checkboxValue,
                                              "checkbox-type": "icon",
                                              "checkbox-tooltip": {
                                                disabledText:
                                                  "Фильтр по всем значениям в справочнике, кроме выбранных",
                                                activeText:
                                                  "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                                notActiveText:
                                                  "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                                              },
                                              multiple: field.multiple
                                                ? field.multiple
                                                : undefined,
                                              searchable: field.searchable
                                                ? field.searchable
                                                : undefined,
                                              clearable: field.clearable
                                                ? field.clearable
                                                : undefined,
                                              placeholder: field.placeholder
                                                ? field.placeholder
                                                : undefined,
                                              items: field.values,
                                            },
                                            on: {
                                              checkboxChange:
                                                _vm.inputCheckboxChange,
                                            },
                                            model: {
                                              value: field.value,
                                              callback: function ($$v) {
                                                _vm.$set(field, "value", $$v)
                                              },
                                              expression: "field.value",
                                            },
                                          })
                                        : _vm._e(),
                                      field.type === "select" && field.groups
                                        ? _c("c-select", {
                                            attrs: {
                                              type: field.type,
                                              label: field.label,
                                              reverse: field.checkboxValue,
                                              "reverse-type": "icon",
                                              "reverse-tooltip": {
                                                disabledText:
                                                  "Фильтр по всем значениям в справочнике, кроме выбранных",
                                                activeText:
                                                  "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                                notActiveText:
                                                  "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                                              },
                                              multiple: field.multiple
                                                ? field.multiple
                                                : undefined,
                                              searchable: field.searchable
                                                ? field.searchable
                                                : undefined,
                                              placeholder: field.placeholder
                                                ? field.placeholder
                                                : undefined,
                                              items: field.values,
                                              groups: field.groups,
                                            },
                                            on: {
                                              changeReverse:
                                                _vm.inputCheckboxChange,
                                            },
                                            model: {
                                              value: field.value,
                                              callback: function ($$v) {
                                                _vm.$set(field, "value", $$v)
                                              },
                                              expression: "field.value",
                                            },
                                          })
                                        : _vm._e(),
                                      field.type === "switcher"
                                        ? _c("c-switcher", {
                                            staticClass:
                                              "employees__fields-item-switcher",
                                            attrs: { label: field.label },
                                            model: {
                                              value: field.value,
                                              callback: function ($$v) {
                                                _vm.$set(field, "value", $$v)
                                              },
                                              expression: "field.value",
                                            },
                                          })
                                        : _vm._e(),
                                      field.type === "range"
                                        ? _c("c-range", {
                                            staticClass:
                                              "employees__fields-item-range",
                                            attrs: {
                                              max: field.max,
                                              min: field.min,
                                              label: field.label,
                                            },
                                            model: {
                                              value: field.value,
                                              callback: function ($$v) {
                                                _vm.$set(field, "value", $$v)
                                              },
                                              expression: "field.value",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            _c("b-col", { attrs: { col: "" } }, [
                              _c(
                                "div",
                                { staticClass: "employees__fields-actions" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "employees__fields-actions-item employees__fields-actions-item-hide-filters",
                                    },
                                    [
                                      _c("c-button", {
                                        attrs: { label: "Свернуть" },
                                        on: { click: _vm.hideFilters },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "employees__fields-actions-item",
                                    },
                                    [
                                      _c("c-button", {
                                        attrs: {
                                          disabled:
                                            !_vm.$refs.route ||
                                            _vm.$refs.route._data
                                              .isLoadingTable,
                                          label: "Сбросить",
                                        },
                                        on: { click: _vm.resetFilters },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "employees__fields-actions-item",
                                    },
                                    [
                                      _c("c-button", {
                                        attrs: {
                                          disabled:
                                            !_vm.$refs.route ||
                                            _vm.$refs.route._data
                                              .isLoadingTable,
                                          label: "Применить",
                                          color: "primary",
                                        },
                                        on: { click: _vm.applyFilters },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "employees__fields-actions-item employees__fields-actions-item-hide-filters-mobile",
                                    },
                                    [
                                      _c("c-button", {
                                        attrs: {
                                          label: "Свернуть фильтры",
                                          color: "white",
                                        },
                                        on: { click: _vm.hideFilters },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.enabledFields && _vm.enabledFields.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "employees__fields-show",
                        class: {
                          "employees__fields-show_active": !_vm.filtersVisible,
                        },
                      },
                      [
                        _c("c-button", {
                          attrs: { label: "Показать фильтры" },
                          on: { click: _vm.showFilters },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c("c-loader", {
                  attrs: {
                    active: true,
                    label: "Инициализация фильтров",
                    height: 300,
                  },
                }),
              ],
          _c(
            "div",
            { staticClass: "employees__tabs" },
            [
              _c("c-tabs", {
                attrs: { items: _vm.tabs.items, "with-routing": "" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "employees__content" },
            [
              _c("router-view", {
                key: _vm.updateList,
                ref: "route",
                attrs: {
                  "enabled-fields": _vm.enabledFields,
                  "enabled-filters": _vm.enabledFilters,
                },
                on: {
                  globalFiltersActive: _vm.setFieldsValues,
                  setTabsQuery: _vm.setTabsQuery,
                  update: _vm.updateGoogleSpreadsheetForm,
                  "edit-worker": _vm.onEmployeeEdit,
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }